import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Button, Div, Flex, Gutter } from '@gaiads/telia-react-component-library';

interface BottomDrawerProps {
  selectedBundles: number[];
  handleRemoveFromSalesChannel: () => void;
  resetSelections: () => void;
  handleDeleteBundle: () => void;
  handleUpdatePrices: (bundleIds: number[]) => void;
  handleEditBundle: (selectedBundle: number) => void;
  handleEditSalesChannels: (selectedBundle: number) => void;
}

const BottomDrawer = ({
  selectedBundles,
  handleRemoveFromSalesChannel,
  resetSelections,
  handleDeleteBundle,
  handleUpdatePrices,
  handleEditBundle,
  handleEditSalesChannels,
}: BottomDrawerProps) => {
  const { t } = useTranslation('bundlesview');

  const selectedBundleCount = selectedBundles.length;

  return (
    <div className="sticky-footer">
      <Div margin={{ horizontal: 'xxlg', vertical: 'md' }}>
        <Flex padding={{ horizontal: 'md' }}>
          <Flex flexItem alignBaseline spaceBetween>
            <Flex flexItem alignBaseline>
              <BodyText color={'white'}>{t('selected.bundleSelected', { count: selectedBundleCount })}</BodyText>
              <Gutter />
              <Button onClick={() => handleUpdatePrices(selectedBundles)} variant={'primaryWhite'}>
                {t('selected.updatePrice', { count: selectedBundleCount })}
              </Button>
              <Gutter />
              {selectedBundleCount === 1 && (
                <>
                  <Button onClick={() => handleEditSalesChannels(selectedBundles[0])} variant={'primaryWhite'}>
                    {t('selected.editSalesChannels')}
                  </Button>
                  <Gutter />
                  <Button onClick={() => handleEditBundle(selectedBundles[0])} variant={'primaryWhite'}>
                    {t('selected.editBundle')}
                  </Button>
                  <Gutter />
                </>
              )}
              {selectedBundleCount > 1 && (
                <>
                  <Button onClick={() => handleRemoveFromSalesChannel()} variant={'destructive'}>
                    {t('selected.removeFromSalesChannel')}
                  </Button>
                  <Gutter />
                </>
              )}
              <Button onClick={() => handleDeleteBundle()} variant={'destructive'}>
                {t('selected.deleteBundle')}
              </Button>
              <Flex />
              <Flex flexItem alignBaseline alignRight>
                <Button textVariantProps={{ color: 'white' }} size={'xl'} onClick={() => resetSelections()} variant={'text'}>
                  {t('selected.cancel')}
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Div>
    </div>
  );
};

export default BottomDrawer;
